<template>
  <div class="login_wrap">
    <i class="back iconfont icon-fanhui" @click="$router.replace('home')"></i>
    <div class="loginHead">
      <img src="../../assets/frame-img/login.png">
    </div>
    <div class="loginContent">
      <div class="loginCell">
        <label class="iconfont icon-yonghuming"/>
        <input placeholder="手机号:" v-model="loginInfo.usename">
      </div>
      <div class="loginCell">
        <label class="iconfont icon-tuwenyanzheng"/>
        <input placeholder="图文验证码:" v-model="loginInfo.captcha">
        <div class="gain">
          <img :src="codeImg" @click="getcaptcha()">
        </div>
      </div>
      <div class="loginCell">
        <label class="iconfont icon-yanzhengma"/>
        <input placeholder="短信验证码:" v-model="loginInfo.code">
        <button class="seedMsg" v-show="show" @click="sendMessage()">发送验证码</button>
        <button class="seedMsg seedMsgDis" v-show="!show">{{timers}}</button>
      </div>
      <div class="loginCell">
        <button class="loginSubmit" @click="login()">登录</button>
      </div>
      <!-- <div class="otherLogin">—— 其他登录方式 ——</div> -->
      <!-- 微信登录 -->
      <!-- <div class="loginCell">
        <div class="otherCell">
          <div class="wxLogin iconfont icon-weixin" @click="loginWX('weixin://')"></div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import { captcha, code, login_mobile, login_abc, update_userinfo } from "../../apis/https.js";
import { setLocalStorage } from "../../utils/storage.js";
import { getToken, setToken } from "@/utils/auth";
import store from "@/store";
import router from "@/router";


export default {
  data() {
    return {
      loginInfo: {
        usename: "",
        code: "",
        captcha_id: "",
        captcha: ""
      },
      values: "获取验证码",
      timers: null,
      timer: 60,
      show: true,
      codeImg: ""
    };
  },
  created() {
    this.getcaptcha();
  },
  activated() {},
  methods: {
    getcaptcha() {
      captcha().then(res => {
        if (res.code != 0) {
          this.loginInfo.captcha_id = res.data.id;
          this.codeImg = res.data.captcha;
        }
      });
    },
    timekeeping() {
      //倒计时
      let auth_timer = setInterval(() => {
        //定时器设置每秒递减
        this.timer--; //递减时间
        this.show = false;
        if (this.timer > 0) {
          this.Verification = true; //60s时间结束还原v-show状态并清除定时器
          const tim = this.timer;
          // this.values=tim+"秒后获取"
          this.timers = tim + "秒后获取";
        } else if (this.timer == 0) {
          clearInterval(auth_timer);
          this.show = true;
          this.timer = 60;
        }
      }, 1000);
    },
    sendMessage() {
      //获取验证码
      if (!/^1((3|5|8){1}\d{1}|70|99)\d{8}$/.test(this.loginInfo.usename)) {
        this.$toast.fail("手机号错误");
        return;
      }
      if (this.loginInfo.captcha == "") {
        this.$toast.fail("请正确填写图形验证码");
        return;
      }
      this.timekeeping();
      this.getcode();
      // this.mylogin()
    },
    getcode() {
      code(
        this.loginInfo.usename,
        this.loginInfo.captcha_id,
        this.loginInfo.captcha
      ).then(res => {
        //page sortType  sortPrice  category_id  search  wxapp_id
        if (res.code == 0) {
          this.$toast.fail("验证码获取失败");
        } else if (res.code == 10500) {
          this.$toast.fail("图形验证码错误");
        }
      });
    },
    login() {
      if (!/^1((3|5|8){1}\d{1}|70|99)\d{8}$/.test(this.loginInfo.usename)) {
        this.$toast.fail("手机号错误");
        return;
      }
      if (!/\d{4,6}/.test(this.loginInfo.code)) {
        this.$toast.fail("请正确填写短信验证码");
        return;
      }

      // if(this.$route.query.r.indexOf('community')>0) {
      //   this.$http.post('/api/user/login', {mobile:this.loginInfo.usename, code:this.loginInfo.code}).then(res=>{
      //     setToken(res.token);
      //     store.dispatch('RefreshUserInfo');
      //     this.$router.replace(this.$route.query.r);
      //   })
      //   return
      // }

      login_mobile(this.loginInfo.usename, this.loginInfo.code)
        .then(res => {
          setLocalStorage("login_token", res.data.token);
          let token = res.data.token;
          login_abc(token)
            .then(res => {
              setToken(res.data.token);
              store.dispatch("RefreshUserInfo");
              store.dispatch("SetUser", token).then(res => {
                update_userinfo({name: res.name, sex: res.sex, avatar: res.img}).then(()=>{
                  window.location.replace(this.$route.query.r);
                })
              });
              // if (this.$route.query.r.indexOf("community") > -1) {
                // window.location.replace(this.$route.query.r);
              // }
            })
          // if (this.$route.query.r.indexOf("community") > -1) {
          //   return;
          // }
        
          // store.dispatch("SetUser", token).then(res => {
          //   // update_userinfo({name: res.name, sex: res.sex, avatar: res.img})
          // });
          // window.location.replace(this.$route.query.r);

        })
        .catch(e => {
        });
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
.login_wrap {
  height: 100vh;
  background: @white;
}
.back {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 20px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: @white;
}
.loginHead {
  img {
    width: 100%;
    pointer-events: none;
    -webkit-user-select: none; /*禁用手机浏览器的用户选择功能 */
    -moz-user-select: none;
  }
}
.loginContent {
  margin-top: 5px;
  padding: 0px 10px;
  .loginCell {
    margin-bottom: 5px;
    display: flex;
    flex-wrap: nowrap;
    text-align: center;
    position: relative;
    label {
      width: 30px;
      display: block;
      font-size: 20px;
      color: @text;
      border-bottom: 1px solid @shalowLine;
      height: 50px;
      line-height: 50px;
      background: @white;
    }
    input {
      margin: 0px;
      border-radius: 0px;
      box-shadow: 0;
      // width: 100%;
      flex: 1 1 auto;
      border: 0px;
      border-bottom: 1px solid @shalowLine;
      height: 50px;
      padding: 0px 10px;
      font-size: 16px;
    }
    .seedMsg {
      width: 100px;
      height: 51px;
      padding: 0px;
      // margin-top: 10px;
      font-size: 12px;
      border: 0px;
      color: #333;
      background: #ddd;
    }
    .seedMsgDis {
      color: @lightP;
    }
    .loginSubmit {
      margin-top: 20px;
      width: 100%;
      border: 0px;
      border-radius: 4px;
      background: @btn;
      color: @white;
      font-size: 14px;
      padding: 15px 0px;
    }
    .gain {
      width: 100px;
      height: 51px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .otherCell {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      .wxLogin {
        position: relative;
        height: 50px;
        width: 50px;
        color: @white;
        background: #45b349;
        font-size: 40px;
        line-height: 50px;
        border-radius: 25px;
      }
    }
  }
  .otherLogin {
    font-size: 12px;
    text-align: center;
    margin: 10px 0px;
  }
}
</style>

